var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseViaOe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 3.5h.978a1.5 1.5 0 0 1 1.374.898L4.59 9.503A2.5 2.5 0 0 0 6.879 11h4.885A2.5 2.5 0 0 0 14 9.618l1.947-3.894-.894-.448-1.947 3.895a1.5 1.5 0 0 1-1.342.829H6.879a1.5 1.5 0 0 1-1.374-.898L3.268 3.997A2.5 2.5 0 0 0 .978 2.5H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12.182 1.525-.707-.707L9 3.293 6.525.818l-.707.707L8.293 4 5.818 6.475l.707.707L9 4.707l2.475 2.475.707-.707L9.707 4z"
})));
export default SvgCloseViaOe;